var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloatingDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560,
    height: 480,
    viewBox: "0 0 560 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Floating documents in pale blue and slate blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#596475",
    strokeWidth: 2.5,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 126) rotate(-9 86 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 256,
    rx: 12,
    fill: "#E8EDF3",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36h121M24 61h121M24 86h91",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 33) rotate(12 86 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 256,
    rx: 12,
    fill: "#E8EDF3",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36h121M24 61h96M24 86h70",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328 204) rotate(6 86 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 256,
    rx: 12,
    fill: "#E8EDF3",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36h121M24 61h109M24 86h83",
    strokeWidth: 9,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingDocuments);
export default __webpack_public_path__ + "static/media/floating-documents.45771f2b29d883977e1f4cca36f3b8e3.svg";
export { ForwardRef as ReactComponent };